import { z } from 'zod'
import {
  SystemParameterKey,
  type ApiLocale,
  type BusinessCardStatus,
  type CommonCommodityReviewItem,
  type CommonCommodityStatus,
  type CompanyEmployeeReviewItem,
  type ContractReviewItem,
  type ContractType,
  type CorporateAccountStatus,
  type CorporateStatus,
  type CourtesyStatus,
  type Currency,
  type Identity,
  type NotificationType,
  type OfferTag,
  type PointStatus,
  type ProgramReviewItem,
  type ProgramStatus,
  type ProgramThreshold,
  type RewardCategory,
  type Route,
  type ShippingMethod,
  type SignOffEntityType,
  type SignOffStatus,
  type RewardsManagementApplicationStatus,
  type RewardsManagementDistributionStatus,
  type RewardsManagementDistributionType,
  type TicketValidityPeriod,
  type TravelPreference,
  type ExclusiveOfferLegacyStatus,
  MaintenanceEnabled
} from '@library/enums'

const Key = SystemParameterKey

export interface DataType {
  [Key.BUSINESS_CARD_STATUS]: BusinessCardStatus
  [Key.CORPORATE_ACCOUNT_STATUS]: CorporateAccountStatus
  [Key.CORPORATE_STATUS]: CorporateStatus
  [Key.CATEGORY_NOTIFY]: NotificationType
  [Key.COMMON_COMMODITY_STATUS]: CommonCommodityStatus
  [Key.COMMON_COMMODITY_REVIEW_ITEM]: CommonCommodityReviewItem
  [Key.COMPANY_EMPLOYEE_REVIEW_ITEM]: CompanyEmployeeReviewItem
  [Key.CONTRACT_REVIEW_ITEM]: ContractReviewItem
  [Key.CONTRACT_TYPE]: ContractType
  [Key.COURTESY_STATUS]: CourtesyStatus
  [Key.CURRENCY]: Currency
  [Key.EXCLUSIVE_OFFER_STATUS]: ExclusiveOfferLegacyStatus
  [Key.IDENTITY]: Identity
  [Key.LANG]: ApiLocale
  [Key.MAINTENANCE_ENABLED]: MaintenanceEnabled
  [Key.OFFER_TAG]: OfferTag
  [Key.POINT_STATUS]: PointStatus
  [Key.PROGRAM_REVIEW_ITEM]: ProgramReviewItem
  [Key.PROGRAM_STATUS]: ProgramStatus
  [Key.PROGRAM_THRESHOLD]: ProgramThreshold
  [Key.REWARD_CATEGORY]: RewardCategory
  [Key.ROUTE]: Route
  [Key.SHIPPING_METHOD]: ShippingMethod
  [Key.SIGN_OFF_ENTITY_TYPE]: SignOffEntityType
  [Key.SIGN_OFF_STATUS]: SignOffStatus
  [Key.TICKET_VALIDITY_PERIOD]: TicketValidityPeriod
  [Key.TRAVEL_PREFERENCE]: TravelPreference
  [Key.REWARDS_APPLICATION_STATUS]: RewardsManagementApplicationStatus
  [Key.REWARDS_DISTRIBUTION_STATUS]: RewardsManagementDistributionStatus
  [Key.REWARDS_DISTRIBUTION_TYPE]: RewardsManagementDistributionType
}

export const systemParameterItemSchema = z.object({
  code: z.string(),
  name: z.string(),
  sort: z.string(),
  enable: z.boolean(),
  parentCode: z.string().optional(),
  parentType: z.string().optional()
})

export interface SystemParameterItem<
  T extends SystemParameterKey
> extends z.infer<typeof systemParameterItemSchema> {
  code: T extends keyof DataType ? DataType[T] : string
}
